import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

interface AccessDay {
  key: string;
  label: string;
  timeFrom: string;
  timeTo: string;
}

interface SubscriptionForm {
  // ── Plan ──────────────────────────────────────
  planType: string;
  plan: string;
  trainer: string;
  activationDate: string;

  // ── Pricing ───────────────────────────────────
  price: number;
  discountPercent: number;
  seasonalDiscount: string;
  totalAfterDiscount: number;
  paidCash: number;
  paidCash2: number;
  paidCard: number;
  paidTransfer: number;
  resetReceiptNo: string;

  // ── Sessions ──────────────────────────────────
  massage: number;
  inbody: number;
  meditation: number;
  cupping: number;
  invitation: number;
  ptSessions: number;
  fitness: number;
  nutration: number;
  freeDays: number;
  training: number;
  cashBack: number;
  freezes: number;
  kidsArea: number;

  // ── Notes & Dates ─────────────────────────────
  comment: string;
  dueDate: string;
  installmentNote: string;
  alertDate: string;
  alertMessage: string;
}
@Component({
  selector: "app-add-subscription",
  templateUrl: "./add-subscription.component.html",
  styleUrls: ["./add-subscription.component.scss"],
})
export class AddSubscriptionComponent implements OnInit {
  form: SubscriptionForm = {
    planType: "إشتراكات رياضية",
    plan: "None",
    trainer: "None",
    activationDate: "",

    price: 0,
    discountPercent: 0,
    seasonalDiscount: "None",
    totalAfterDiscount: 0,
    paidCash: 0,
    paidCash2: 0,
    paidCard: 0,
    paidTransfer: 0,
    resetReceiptNo: "NO",

    massage: 0,
    inbody: 0,
    meditation: 0,
    cupping: 0,
    invitation: 0,
    ptSessions: 0,
    fitness: 0,
    nutration: 0,
    freeDays: 0,
    training: 0,
    cashBack: 0,
    freezes: 0,
    kidsArea: 0,

    comment: "",
    dueDate: "",
    installmentNote: "",
    alertDate: "",
    alertMessage: "",
  };

  // ── Access Days ─────────────────────────────────
  accessDays: AccessDay[] = [
    { key: "saturday", label: "السبت", timeFrom: "00:00", timeTo: "23:59" },
    { key: "sunday", label: "الأحد", timeFrom: "00:00", timeTo: "23:59" },
    { key: "monday", label: "الإثنين", timeFrom: "00:00", timeTo: "23:59" },
    { key: "tuesday", label: "الثلاثاء", timeFrom: "00:00", timeTo: "23:59" },
    { key: "wednesday", label: "الأربعاء", timeFrom: "00:00", timeTo: "23:59" },
    { key: "thursday", label: "الخميس", timeFrom: "00:00", timeTo: "23:59" },
    { key: "friday", label: "الجمعة", timeFrom: "00:00", timeTo: "23:59" },
  ];

  constructor(private dialogRef: MatDialogRef<AddSubscriptionComponent>) {}

  ngOnInit(): void {
    const today = new Date().toISOString().split("T")[0];
    this.form.activationDate = today;
    this.form.dueDate = today;
    this.form.alertDate = today;

    // Recalculate total whenever price/discount changes
  }

  // ── Auto-calculate total after discount ─────────
  calculateTotal(): void {
    const discountAmount = (this.form.price * this.form.discountPercent) / 100;
    this.form.totalAfterDiscount = Math.max(
      0,
      this.form.price - discountAmount,
    );
  }

  // ── Submit ────────────────────────────────────────
  onSubmit(): void {
    const payload = {
      ...this.form,
      accessDays: this.accessDays,
    };
    console.log("إضافة إشتراك:", payload);
    this.dialogRef.close(payload);
  }

  // ── Close ─────────────────────────────────────────
  onClose(): void {
    this.dialogRef.close(null);
  }
}
